module.exports = __webpack_public_path__ + "static/media/cl.7709f09f.svg";